// extracted by mini-css-extract-plugin
module.exports = {"plus-button":"plus-button___mn4RY","icon":"icon___bNlDI"};